import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import ContactForm from './ContactForm';
import { instituteMock } from '../data/mock';

const Contact = () => {
  const { contact } = instituteMock;

  return (
    <section className="section-padding bg-secondary" id="contact-section">
      <div className="container">
        <div className="contact-header">
          <h2 className="heading-1" style={{ marginBottom: '48px', textAlign: 'center' }}>
            Fale Conosco
          </h2>
        </div>
        
        <div className="grid-two-column">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">
                <Phone size={24} />
              </div>
              <div>
                <p className="body-small text-secondary">Telefone</p>
                <p className="body-large">{contact.phone}</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <Phone size={24} />
              </div>
              <div>
                <p className="body-small text-secondary">WhatsApp</p>
                <p className="body-large">{contact.whatsapp}</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <Mail size={24} />
              </div>
              <div>
                <p className="body-small text-secondary">Email</p>
                <p className="body-large">{contact.email}</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MapPin size={24} />
              </div>
              <div>
                <p className="body-small text-secondary">Endereço</p>
                <p className="body-regular">
                  {contact.address.street}<br />
                  {contact.address.district}, {contact.address.city} - {contact.address.state}<br />
                  CEP {contact.address.zipCode}
                </p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <Clock size={24} />
              </div>
              <div>
                <p className="body-small text-secondary">Horário de atendimento</p>
                <p className="body-regular">{contact.hours}</p>
              </div>
            </div>

            <div className="map-container" style={{ marginTop: '32px' }}>
              <iframe
                src={contact.mapUrl}
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '0px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização do Instituto Retina Viva"
              ></iframe>
            </div>
          </div>

          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
